// // src/components/QuizModal.jsx
// import React, { useState } from "react";

// export default function QuizModal({ open, onClose }) {
//   const [step, setStep] = useState(0);
//   const [answers, setAnswers] = useState({});

//   if (!open) return null;

//   const handleAnswer = (field, value) => {
//     setAnswers({ ...answers, [field]: value });
//     setStep(step + 1);
//   };

//   const questions = [
//     {
//       question: "Which stage are you in?",
//       field: "stage",
//       options: ["Student", "Graduate", "Professional"],
//     },
//     {
//       question: "What’s your main goal?",
//       field: "goal",
//       options: ["Career Guidance", "Skill Development", "Job Placement"],
//     },
//     {
//       question: "Which area excites you the most?",
//       field: "interest",
//       options: ["Technology", "Business", "Creative Arts", "Science"],
//     },
//   ];

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//       <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-8 relative">
//         {/* Close button */}
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-2xl"
//         >
//           &times;
//         </button>

//         {/* Questions */}
//         {step < questions.length ? (
//           <div className="text-center">
//             <h2 className="text-xl font-bold mb-4">{questions[step].question}</h2>
//             <div className="flex flex-col gap-3">
//               {questions[step].options.map((opt) => (
//                 <button
//                   key={opt}
//                   onClick={() => handleAnswer(questions[step].field, opt)}
//                   className="px-4 py-2 rounded-lg border border-indigo-500 text-indigo-600 hover:bg-indigo-100 transition"
//                 >
//                   {opt}
//                 </button>
//               ))}
//             </div>
//           </div>
//         ) : (
//           <div className="text-center">
//             <h2 className="text-2xl font-bold text-green-600 mb-4">
//               🎉 Your Roadmap is Ready!
//             </h2>
//             <p className="text-gray-700 mb-6">
//               Based on your answers, we’ll craft a personalized career roadmap.
//             </p>
//             <button
//               onClick={() => {
//                 onClose();
//                 document
//                   .getElementById("roadmap")
//                   ?.scrollIntoView({ behavior: "smooth" });
//               }}
//               className="px-6 py-3 bg-indigo-600 text-white rounded-full shadow-lg hover:bg-indigo-700 transition"
//             >
//               View My Roadmap 🚀
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
// src/components/QuizModal.jsx
import React, { useState } from "react";

export default function QuizModal({ open, onClose, onComplete }) {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});

  if (!open) return null;

  const handleAnswer = (field, value) => {
    setAnswers({ ...answers, [field]: value });
    setStep(step + 1);
  };

  const questions = [
    {
      question: "Which stage are you in?",
      field: "stage",
      options: ["8th-10th Student", "11th-12th Student", "Graduate / Job Seeker", "Working Professional"],
    },
    {
      question: "What's your main goal?",
      field: "goal",
      options: ["Career Guidance", "Stream/Course Selection", "Skill Development", "Job Placement", "Career Switch"],
    },
    {
      question: "Which area excites you the most?",
      field: "interest",
      options: ["Engineering", "Medical", "Commerce / CA", "Technology / IT", "Business", "Creative Arts", "Science / Research"],
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center h-screen bg-black/50 backdrop-blur-sm">
      {/* Modal Box */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 relative animate-scaleIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-2xl"
        >
          &times;
        </button>

        {/* Steps */}
        {step < questions.length ? (
          <div className="text-center">
            <h2 className="text-xl font-bold mb-4">{questions[step].question}</h2>
            <div className="flex flex-col gap-3">
              {questions[step].options.map((opt) => (
                <button
                  key={opt}
                  onClick={() => handleAnswer(questions[step].field, opt)}
                  className="px-4 py-2 rounded-lg border border-indigo-500 text-indigo-600 hover:bg-indigo-100 transition"
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-green-600 mb-4">
              🎉 Your Roadmap is Ready!
            </h2>
            <p className="text-gray-700 mb-6">
              Based on your answers, we’ll craft a personalized career roadmap.
            </p>
            <button
              onClick={() => {
                onComplete(answers);
                document
                  .getElementById("roadmap")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="px-6 py-3 bg-indigo-600 text-white rounded-full shadow-lg hover:bg-indigo-700 transition"
            >
              View My Roadmap 🚀
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
